
import Errors from '@shared/error/errors';
import payoutScheduleStore from '@modules/subproperty-settings/finantial-settings/finantial-settings-payout-schedule/finantial-settings-payout-schedule-page-store';
import payoutMethodsStore from  '@modules/subproperty-settings/finantial-settings/finantial-settings-payout-methods/finantial-settings-payout-methods-page-store';
import { StripeConnectedAccountService } from '@modules/stripe/stripe-connected-account/stripe-connected-account-service';
import { SubpropertyService } from '@modules/subproperty/subproperty-service';

export default {
  namespaced: true,

  modules: {
    payoutSchedule: payoutScheduleStore,
    payoutMethods: payoutMethodsStore,
  },
  
  state: {
    subproperty: null,
    connectedAccount: null,
    loadingConnectedAccount: false,
  },

  getters: {
    connectedAccount: state => state.connectedAccount,
    subproperty: state => state.subproperty,
    subpropertyLogoUrl: state => state.subproperty ? state.subproperty.logo[0].publicUrl : null,
    loadingConnectedAccount: state => state.loadingConnectedAccount,
    isConnectedPersonEmpty: (state, getters, rootState) => rootState.stripePerson.list.rows.length === 0,
    isPayoutMethodsEmpty: (state, getters, rootState) => rootState.paymentSettings.payoutMethods.payoutsMethods.length === 0,
  },
  mutations: {
    CONNECTED_ACCOUNT_STARTED(state) {
      state.loadingConnectedAccount = true;
      state.connectedAccount = null;
      state.subproperty = null;
    },
    
    CONNECTED_ACCOUNT_SUCCESS(state, { connectedAccount, subproperty }) {
      state.loadingConnectedAccount = false;
      state.connectedAccount = connectedAccount;
      state.subproperty = subproperty;
    },
    
    CONNECTED_ACCOUNT_ERROR(state, { subproperty }) {
      state.loadingConnectedAccount = false;
      state.connectedAccount = null;
      state.subproperty = subproperty;
    },
  },
  actions: {
    async doFindConnectedAccount({ commit }, { subpropertyId, disableLoading = false }) {
      if (!disableLoading) commit('CONNECTED_ACCOUNT_STARTED')
      try {
        const connectedAccount = await StripeConnectedAccountService.connectedAccountBySubpropertyId({ subpropertyId });
        const subproperty = await SubpropertyService.find(subpropertyId, { type: 'subproperty' });

        if (connectedAccount && connectedAccount.id) {
          commit('CONNECTED_ACCOUNT_SUCCESS', { connectedAccount, subproperty });
        } else {
          commit('CONNECTED_ACCOUNT_ERROR', { subproperty });
        }
      } catch (error) {
        commit('CONNECTED_ACCOUNT_ERROR');
        Errors.handle(error);
      }
    },
  }
};
